import { useTranslation } from "react-i18next";
import helpers from "../../../../Utils/helpers";
import Spinner from "../../../Fundamentals/Spinner/Spinner";
import Checkbox from "../../../Checkbox";

export function DiscountsTable({ discounts, isLoading, onToggleSelect, isSelected }) {
    const { t } = useTranslation();

    return <table className="table table-stripe skynet-table-no-divider">
        <thead>
            <tr>
                <th width={"5%"}></th>
                <th width={"35%"}>{t("subscriptionsDiscountTable.discounts")}</th>
                <th width={"25%"}>{t("common.package")}</th>
                <th>{t("common.startdate")}</th>
                <th>{t("common.enddate")}</th>
            </tr>
        </thead>
        <tbody>
            {isLoading ? (
                <tr>
                    <td colSpan={5}><Spinner /></td>
                </tr>
            ) : discounts?.length > 0 ? discounts.map((discount) => (
                <tr key={discount._uniqueId}>
                    <td>
                        <Checkbox 
                            checked={isSelected(discount)} 
                            onChange={() => onToggleSelect(discount)}
                        />
                    </td>
                    <td>{discount.name}</td>
                    <td>{discount.packageName}</td>
                    <td>{helpers.formatDate(discount.startDate)}</td>
                    <td>{helpers.formatDate(discount.endDate)}</td>
                </tr>
            )) : (
                <tr>
                    <td colSpan={5}><em>{t("subscriptionsDiscountTable.noDiscounts")}</em></td>
                </tr>
            )}
        </tbody>
    </table>
}